import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Icon from '../../components/icons';
import { URLS } from '../../_config';
import General from './_components/general';
import Warranty from './_components/warranty';
import Maintenance from './_components/Maintenance/maintenance';
import PartsList from './_components/partsList';
import Accounting from './_components/Accounting/accounting';
import Notes from './_components/notes';
import Attachments from './_components/attachments';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Drawer from '../../components/Drawer';
import Button from '../../components/elements/button';
import CreateAssets from './_components/createAssets';
import { Dropdown, Menu } from '../../components/Dropdown';
import CreateWorkOrder from '../WorkOrder/_components/createWorkOrder';
import { useChecklistApi } from '../../store/api/hooks/checklistApiHook';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { useUserSelector } from '../../store/selectors/userSelector';
import { getPermissionInfo } from '../../_common/functions';

const AssetsDetails: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const [tab, setTab] = useState('general');
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const [asset, setAsset] = useState<any>(null);
    const [purchaseCost, setPurchaseCost] = useState<number>(0);

    const [assetdetails, setAssetDatails] = useState<any>(null)
    const createDrwerWORef: any = useRef();
    const createFacilityRef: any = useRef();
    const [editData, setEditData] = useState<any>(null);
    const [copyData, setCopyData] = useState<any>(null);
    const [qrImg, setQrImg] = useState<any>(null);
    const createWORef: any = useRef();
    const checklistAPI: any = useChecklistApi();
    const { confirm } = useDialog();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const getAssetsList = (assetID: any) => {
        const payload = {
            assetID: assetID
        };

        assetsAPI.getAssetsList(payload, async (data: any) => {
            setPurchaseCost(data?.assetList?.[0]?.purchaseCost ?? 0);
            const assetInfo = data?.assetList?.[0] ?? null;
            const groupName = assetInfo?.groupName;

            setAsset(assetInfo);

            let woassetsmap: any = [{
                woAssetMappingID: null,
                workOrderID: null,
                assetID: assetID,
                assetCode: assetInfo?.assetCode,
                name: assetInfo?.assetName,
                statusID: assetInfo?.statusID,
                statusName: assetInfo?.statusName,
                vehicleLastInspection: assetInfo?.vehicleLastInspection,
                warrantyEndDate: assetInfo?.warrantyEndDate
            }];

            let checklistmap: any = await new Promise((resolve, reject) => {
                checklistAPI.getChecklists({ assetIDs: assetID }, (resp: any) => {
                    if (resp?.checklistList?.length > 0) {
                        resolve(resp.checklistList);
                    } else {
                        resolve([]);
                    }
                }, (error: any) => {
                    reject([]);
                });
            }).catch(() => []);

            // Final merged asset object
            const dataasst: any = {
                ...assetInfo,
                groupName: groupName, // Just to be explicit
                prefillData_wo: {
                    model: {
                        facilityID: assetInfo?.facilityID,
                        subFacilityID: assetInfo?.subFacilityID,
                    },
                    assets: woassetsmap,
                    checklist: checklistmap,
                }
            };
            console.log("WR data ->", data);
            setAssetDatails(dataasst);
        }, (error: any) => { });
    };

    const qrcode = (assetID: any) => {

        const payload = { qrAssetList: [{ assetID: Number(assetID), qty: 1 }], assetNameInQR: false, provideImage: true };

        assetsAPI.ExportQrCodePng(payload, (resp: any) => {
            console.log("resp4444444", resp.base64Image)
            setQrImg(resp?.base64Image);
        },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    }

    const handleActionChange = (e: any, params5: any) => {
        const action = e;
        if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
            toast.error(`Unauthorized attempt: ${action}`);
            return;
        } else {
            const rowData = params5;

            switch (action) {
                case "edit":
                    // Implement edit action
                    setEditData(rowData);
                    addNewAssetRef.current.open();
                    console.log("Edit action for row: ", rowData);
                    break;
                case "delete":
                    // Implement delete action
                    confirm({
                        type: 'delete',
                        title: 'Delete Asset',
                        message: 'Are you sure you want to delete this asset?',
                        onConfirm: () => {
                            assetsAPI.deleteAsset({ assetID: params.id }, (data: any, msg: any) => {
                                toast.success(msg);
                                navigate(URLS.ASSETS);

                            }, (error: any) => {
                                toast.error(error);
                            });
                        }
                    });
                    break;
                case "duplicate":
                    const duplicateData = asset;
                    delete duplicateData.assetID;
                    setCopyData(duplicateData);
                    addNewAssetRef.current.open();
                    break;
                case "convert-to-owned":
                    console.log("Convert to Owned Asset action for row: ", rowData);
                    setCopyData(rowData); // Keep the original assetID for convert-to-owned
                    addNewAssetRef.current.open();
                    break;
                case "move-asset":
                    // Implement move asset action
                    console.log("Move Asset action for row: ", rowData);
                    break;


                default:
                    console.log("Unknown action: ", action);
                    break;
            }
        }

    };
    const toggleDiv = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (params.id) {
            getAssetsList(params.id);
            qrcode(params.id)


        }
    }, [params]);

    return (
        <Layout>
            <Header title={asset?.name} back={asset?.statusID === 9 ? URLS.WIPASSETS : URLS.ASSETS}>
                <Header.Right>
                    <Drawer _ref={addNewAssetRef} isAfterOpenRender={true} onClose={() => { }} outsideClose={false}>
                        <Drawer.Button>
                            <Button theme='light' disabled={!getPermissionInfo(location.pathname, 'Edit', loggedinuser)}>Edit</Button>
                        </Drawer.Button>
                        <Drawer.Content title={asset ? copyData ? 'Create New Assets' : 'Edit Assets' : 'Create New Assets'} className='!w-[39.563rem]'>
                            {!getPermissionInfo(location.pathname, "Edit", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don’t have permission to access this form.
                                </div>
                            ) : (
                                <CreateAssets editData={copyData ? copyData : asset} actionType={copyData && !editData ? 'convert-to-owned' : 'edit'} onCreate={() => {
                                    setEditData(null);
                                    setCopyData(null);
                                    getAssetsList(params.id);
                                    qrcode(params.id);
                                    setReloadKey(prev => prev + 1);
                                    addNewAssetRef.current.close();
                                }} onCancel={() => {
                                    setEditData(null);
                                    setCopyData(null);
                                    getAssetsList(params.id);
                                    qrcode(params.id);
                                    setReloadKey(prev => prev + 1);
                                    addNewAssetRef.current.close();
                                }} />)}
                        </Drawer.Content>
                    </Drawer>


                    <Drawer _ref={createDrwerWORef} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        getAssetsList(params.id);
                        setEditData(null);
                        setCopyData(null)
                        createDrwerWORef?.current?.close();
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, 'Create Task Respected Asset', loggedinuser)}>Create New Task</Button>
                        </Drawer.Button>
                        <Drawer.Content title={`Create New Task`} className='!w-[39.563rem]'>
                            {!getPermissionInfo(location.pathname, "Create Task Respected Asset", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don’t have permission to access this form.
                                </div>
                            ) : (<CreateWorkOrder _ref={createWORef} editData={null} prefillData={assetdetails?.prefillData_wo || null} onCreate={() => {
                                setEditData(null);
                                setAsset(null);
                                setCopyData(null)
                                getAssetsList(params.id);
                                createDrwerWORef?.current?.close();

                            }} onCancel={() => {
                                setEditData(null);
                                setAsset(null);
                                getAssetsList(params.id);
                                setCopyData(null)
                                createDrwerWORef?.current?.close();

                            }} />)}
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' className='h-[2.25rem]'><Icon name='threedote' size={1.25} className='' /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu disabled={!getPermissionInfo(location.pathname, 'Delete', loggedinuser)} onClick={() => { handleActionChange('delete', asset) }}>Delete</Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, 'Duplicate', loggedinuser)} onClick={() => { handleActionChange('duplicate', asset) }}>Duplicate</Menu>
                            {asset?.assetGroupID === 2 && (
                                <Menu disabled={!getPermissionInfo(location.pathname, 'Convert to Owned Asset', loggedinuser)} onClick={() => { handleActionChange('convert-to-owned', asset) }}>Convert to Owned Asset</Menu>
                            )}
                        </Dropdown.Content>
                    </Dropdown>


                </Header.Right>


            </Header>
            <div className='flex justify-between items-center px-5 border-b border-gray-200'>
                <div className='px-5  h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium'>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'general' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('general')}>
                        General
                    </button>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'warranty' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => { setTab('warranty') }}>
                        Warranty
                    </button>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'maintenance' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => {
                        setTab('maintenance')

                    }}>
                        Maintenance
                    </button>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'parts-list' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => {
                        setTab('parts-list')

                    }}>
                        Parts List
                    </button>
                    {asset?.groupName == 'Owned Assets' &&
                        <button className={`hover:text-black relative flex h-full items-center ${tab == 'accounting' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => {
                            setTab('accounting')

                        }}>
                            Accounting
                        </button>
                    }
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'notes' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('notes')}>
                        Notes
                    </button>
                    <button className={`hover:text-black relative flex h-full items-center ${tab == 'attachments' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('attachments')}>
                        Attachments
                    </button>
                </div>

                <Button onClick={toggleDiv} theme='light'>QR Code</Button>




            </div>
            {isOpen &&
                <div
                    className={`mt-6 absolute w-[16.6rem] right-6 top-[6rem] z-20 p-6 bg-white rounded-xl shadow-lg transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[300px]' : 'max-h-0'
                        }`}
                    style={{
                        maxHeight: isOpen ? '300px' : '0', // For smooth transition
                    }}
                >
                    <img src={qrImg} className='w-[13.5rem] h-[13.5rem]' />

                </div>
            }

            <div className={`px-5 overflow-y-auto`} style={{ maxHeight: `calc(100vh - 125px)` }}>
                {tab === 'general' && <General reloadKey={reloadKey} />}
                {tab === 'warranty' && <Warranty reloadKey={reloadKey}/>}
                {tab === 'maintenance' && <Maintenance/>}
                {tab === 'parts-list' && <PartsList/>}
                {tab === 'accounting' && <Accounting purchaseCost={purchaseCost} onAssetUpdate={() => getAssetsList(params.id)} />}
                {tab === 'notes' && <Notes />}
                {tab === 'attachments' && <Attachments />}
            </div>
        </Layout>
    );
};

export default AssetsDetails;